import { NodeRenderer } from '@contentful/rich-text-react-renderer';
import { MARKS, Block, Inline } from '@contentful/rich-text-types';

const renderInlineContent = (block: Block | Inline) => {
    if (!('content' in block)) return null;
    return block.content.map((segment, i) => {
        if (!('value' in segment)) return null;
        const marks = segment.marks || [];
        let rendered: React.ReactNode = segment.value;
        for (const mark of marks) {
            if (mark.type === MARKS.BOLD) rendered = <strong key={`${i}-b`}>{rendered}</strong>;
            if (mark.type === MARKS.ITALIC) rendered = <em key={`${i}-i`}>{rendered}</em>;
        }
        return <span key={i}>{rendered}</span>;
    });
};

export const BlockquoteRender = (({ data, content }) => {
    if (!content || content.length === 0) return null;

    // first content block is the quote text
    const quoteContent = renderInlineContent(content[0] as Block | Inline);
    if (!quoteContent) return null;

    // remaining content blocks are the citation
    const citationBlocks = content.slice(1);
    const citationContent =
        citationBlocks.length > 0
            ? citationBlocks.map((block, i) => <span key={i}>{renderInlineContent(block as Block | Inline)}</span>)
            : null;

    return (
        <figure className="w-full max-w-2xl pt-8 mx-auto border-t-4 border-gray-900 mt-14">
            <blockquote className="text-2xl font-bold leading-tight md:text-5xl font-headline border-l-4 border-gray-100 pl-6 md:pl-10">
                {quoteContent}
            </blockquote>
            {citationContent && (
                <figcaption className="text-xl text-gray-900 mt-0 pt-6 border-l-4 border-gray-100 pl-6 md:pl-10">
                    {citationContent}
                </figcaption>
            )}
        </figure>
    );
}) as NodeRenderer;

export default BlockquoteRender;
